import { render, staticRenderFns } from "./ViewStandardisedJobProfiles.vue?vue&type=template&id=fe07dc50&scoped=true"
import script from "./ViewStandardisedJobProfiles.vue?vue&type=script&lang=ts"
export * from "./ViewStandardisedJobProfiles.vue?vue&type=script&lang=ts"
import style0 from "./ViewStandardisedJobProfiles.vue?vue&type=style&index=0&id=fe07dc50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe07dc50",
  null
  
)

export default component.exports